import { AxiosError } from "axios";

import { ProblemDetails, ValidationProblemDetails } from "@/core/api/generated/v1";

import ServerBaseErrorModel from "../models/api/ServerBaseErrorModel";
import { ProblemDetailsAny, ValidationProblemDetailsWithExtensions } from "../ts/problemDetails";

export class ProblemDetailsHelper {
  public static isProblemDetails(value: any): value is ProblemDetails {
    const problemDetails = value as Nil<ProblemDetails>;
    return (
      !!problemDetails && !!problemDetails.status && !!problemDetails.type && !!problemDetails.title
    );
  }

  public static isValidationProblemDetails(value: any): value is ValidationProblemDetails {
    const problemDetails = value as Nil<ValidationProblemDetails>;
    return !!problemDetails && this.isProblemDetails(problemDetails) && !!problemDetails.errors;
  }

  public static getWithExtensions(
    problemDetails: ValidationProblemDetails,
  ): ValidationProblemDetailsWithExtensions {
    return problemDetails as ValidationProblemDetailsWithExtensions;
  }

  public static getProblemDetailsFromError(err: any): ValidationProblemDetails | undefined {
    if (!err) {
      return undefined;
    }

    const baseError = err as Nil<ServerBaseErrorModel>;
    if (err instanceof ServerBaseErrorModel || baseError?.problemDetails) {
      return baseError?.problemDetails;
    }

    if (err instanceof AxiosError) {
      return this.getProblemDetailsFromAxiosError(err);
    }

    return undefined;
  }

  public static getProblemDetailsFromAxiosError(
    err: Nil<AxiosError>,
  ): ValidationProblemDetails | undefined {
    if (!err || !(err instanceof AxiosError)) {
      return undefined;
    }
    const problemDetails = err.response?.data as Nil<ProblemDetailsAny>;
    return ProblemDetailsHelper.isProblemDetails(problemDetails) ? problemDetails : undefined;
  }
}
